import api from '../../../api/index'

export function myTeam() {
  return api.get(`myTeam`);
}

export function engagementRepWeekly(id){
    return api.get(`v2/engagements?rep_id=${id}&state=active`)
}

export function temporaryAssignment(payload){
  return api.put('v2/temporary-assign-engagement', payload);
}

export function temporaryEngagement(id){
  return api.get(`v2/engagements?temporary_rep_id=${id}&state=active`);
}


export function repReminder(id, start, end){
    return api.get(`rep_reminders/${id}?start=${start}&end=${end}`)
}

export function roleUser(query){
  return api.get(`role_users?role=${query}`);
}